import { useEffect, useState } from "react";
import { G } from "../../constants/theme";
import { NAV_ITEMS } from "../../constants/navigation";

export default function Footer({ onNavigate }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <footer
      style={{
        background: G.surface,
        borderTop: `1px solid ${G.border}`,
        padding: "50px 0 28px",
      }}
    >
      <div style={{ maxWidth: 1140, margin: "0 auto", padding: "0 clamp(16px,4vw,44px)" }}>
        {/* Main grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr 1fr",
            gap: 48,
            paddingBottom: 32,
            borderBottom: `1px solid ${G.border}`,
            marginBottom: 24,
          }}
        >
          {/* Brand */}
          <div>
            <div
              style={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: 22,
                color: G.white,
                letterSpacing: 2,
              }}
            >
              MIDDLE EAST BLACK CARBON
            </div>
            <div
              style={{
                fontFamily: "monospace",
                fontSize: 8,
                color: G.green,
                letterSpacing: 2.5,
                textTransform: "uppercase",
                margin: "4px 0 14px",
              }}
            >
              Recovered Carbon Black Powder Supplier
            </div>
            <p style={{ fontSize: 13, color: G.muted, maxWidth: 280, lineHeight: 1.65 }}>
              Industrial rCB powder from tire pyrolysis. Bulk supply available.
              <br />
              Production: Syria · Commercial: Canada
            </p>
          </div>

          {/* Navigation */}
          <div>
            <div
              style={{
                fontFamily: "monospace",
                fontSize: 10,
                letterSpacing: 2,
                color: G.green,
                textTransform: "uppercase",
                marginBottom: 16,
              }}
            >
              Navigation
            </div>
            {NAV_ITEMS.map((n) => (
              <div
                key={n.id}
                onClick={() => onNavigate(n.id)}
                style={{
                  fontSize: 13,
                  color: G.muted,
                  marginBottom: 9,
                  cursor: "pointer",
                  transition: "color .2s",
                }}
              >
                {n.label}
              </div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <div
              style={{
                fontFamily: "monospace",
                fontSize: 10,
                letterSpacing: 2,
                color: G.green,
                textTransform: "uppercase",
                marginBottom: 16,
              }}
            >
              Contact
            </div>
            <p style={{ fontSize: 13, color: G.muted, lineHeight: 1.75 }}>
              info@middleeastblackcarbon.ca
              <br />
              <br />
              Production: Syria
              <br />
              Commercial: Canada
              <br />
              <br />
              middleeastblackcarbon.com
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 8,
            textAlign: "center",
          }}
        >
          <span style={{ fontFamily: "monospace", fontSize: 10, color: G.muted, letterSpacing: 1 }}>
            © 2025 Middle East Black Carbon. All rights reserved.
          </span>
          <span style={{ fontFamily: "monospace", fontSize: 10, color: G.border, letterSpacing: 1 }}>
            rCB POWDER SUPPLIER — TIRE PYROLYSIS
          </span>
        </div>
      </div>
    </footer>
  );
}
